type Attempt = { fingerprint: string; key: string }
const attempts = new Map<string, Attempt>()

const normalize = (value: any): any => Array.isArray(value)
    ? value.map(normalize)
    : value && typeof value === 'object'
        ? Object.fromEntries(Object.keys(value).sort().map(key => [key, normalize(value[key])]))
        : value

export async function checkoutAttempt(storageKey: string, payload: Record<string, any>): Promise<string> {
    const { checkout_key, marketing_tracking, is_valid, ...order } = payload
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(normalize(order))))
    const fingerprint = Array.from(new Uint8Array(digest), value => value.toString(16).padStart(2, '0')).join('')
    let previous = attempts.get(storageKey)
    try { previous = JSON.parse(localStorage.getItem(storageKey) || 'null') ?? previous } catch { /* Use the current page's attempt when storage is unavailable. */ }
    if (previous?.fingerprint === fingerprint) {
        attempts.set(storageKey, previous)
        return previous.key
    }
    const attempt = { fingerprint, key: crypto.randomUUID() }
    attempts.set(storageKey, attempt)
    try { localStorage.setItem(storageKey, JSON.stringify(attempt)) } catch { /* The in-memory attempt still protects retries on this page. */ }
    return attempt.key
}

export function completeCheckoutAttempt(storageKey: string, key: string): void {
    if (attempts.get(storageKey)?.key === key) attempts.delete(storageKey)
    try {
        if (JSON.parse(localStorage.getItem(storageKey) || 'null')?.key === key) localStorage.removeItem(storageKey)
    } catch { /* Storage may be unavailable. */ }
}
